import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const roParts = (iso) => {
  const d = new Date(iso);
  return { date: d.toLocaleDateString("sv-SE", { timeZone: "Europe/Bucharest" }), hour: Number(d.toLocaleString("en-GB", { hour: "2-digit", hour12: false, timeZone: "Europe/Bucharest" })) };
};
export const defaultSlot = () => roParts(new Date(Date.now() + 86400000).toISOString().slice(0, 10) + "T08:00:00Z");

export const DateHourFields = ({ value, onChange }) => (
  <div className="flex gap-2">
    <input data-testid="schedule-date-input" type="date" value={value.date} onChange={(e) => onChange({ ...value, date: e.target.value })} className="flex-1 rounded-md border border-zinc-300 bg-transparent px-3 py-1.5 text-sm" />
    <select data-testid="schedule-hour-select" value={value.hour} onChange={(e) => onChange({ ...value, hour: Number(e.target.value) })} className="rounded-md border border-zinc-300 bg-transparent px-3 py-1.5 text-sm">
      {Array.from({ length: 24 }, (_, h) => <option key={h} value={h}>{String(h).padStart(2, "0")}:00</option>)}
    </select>
  </div>
);

export const ScheduleDialog = ({ q, onClose, onSave }) => {
  const [v, setV] = useState(() => roParts(q.slot_at));
  const [busy, setBusy] = useState(false);
  const save = async () => { setBusy(true); try { await onSave({ slot_key: v.date, hour: v.hour }); } finally { setBusy(false); } };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="schedule-dialog" className="max-w-sm">
        <DialogHeader><DialogTitle>Data și ora postării</DialogTitle></DialogHeader>
        <DateHourFields value={v} onChange={setV} />
        <p className="text-[11px] text-zinc-500">Se schimbă doar postarea aceasta; restul programului rămâne neschimbat.</p>
        <button data-testid="schedule-save" onClick={save} disabled={busy || !v.date} className="inline-flex items-center justify-center gap-2 rounded-full bg-amber-400 px-4 py-2 text-sm font-semibold text-zinc-950 disabled:opacity-50">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Salvează
        </button>
      </DialogContent>
    </Dialog>
  );
};
